import { ReferenceInput, SelectInput } from "react-admin";
import * as React from "react";
import { SourceCustomer } from "../../../Pages/Admin/Customer";

const CustomerInput = props => {
  return (
    <ReferenceInput
      label="CUSTOMER NAME"
      source="customerId"
      reference={SourceCustomer}
      translateChoice={false}
      {...props}
    >
      <SelectInput optionText="customerName" optionValue="id" />
    </ReferenceInput>
  );
};

export default CustomerInput;
